import type { SVGProps } from 'react';
const SvgIconProduct = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 6.308v3.384q0 .135.01.269a3.75 3.75 0 0 0 2.117 3.112l3.25 1.56a3.75 3.75 0 0 0 3.246 0l3.25-1.56A3.75 3.75 0 0 0 15 9.693V6.307a3.75 3.75 0 0 0-2.127-3.381l-.639-.307-.007-.003-2.604-1.25a3.75 3.75 0 0 0-3.246 0l-3.25 1.56A3.75 3.75 0 0 0 1 6.307m7.228-3.799c.256.026.508.096.746.21l2.607 1.252a.5.5 0 0 1 0 .898l-.003.002-2.604 1.25q-.004 0-.008.003a2.25 2.25 0 0 1-1.94-.003L4.422 4.87a.5.5 0 0 1 0-.902l2.604-1.25a2.25 2.25 0 0 1 1.202-.21M6.966 7.756a.5.5 0 0 1 .284.45v4.387a.5.5 0 0 1-.715.452h-.001L3.776 11.72A2.25 2.25 0 0 1 2.5 9.692V6.407a.5.5 0 0 1 .716-.451zm2.647-.279-.58.279a.5.5 0 0 0-.283.45v4.387a.5.5 0 0 0 .715.452h.001l2.758-1.324A2.25 2.25 0 0 0 13.5 9.692V6.407a.5.5 0 0 0-.716-.451l-.55.264-.007.003-2.604 1.25z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconProduct;
